var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dv-decoration-1',{staticClass:"decoration-container",attrs:{"color":_vm.color}})
}
var staticRenderFns = []

export { render, staticRenderFns }